import type { SVGProps } from "react";

export default function TableIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 6.66669V13.3334M2 10H14M2 6.66669H14M4.13333 13.3334H11.8667C12.6134 13.3334 12.9868 13.3334 13.272 13.188C13.5229 13.0602 13.7269 12.8562 13.8547 12.6054C14 12.3202 14 11.9468 14 11.2V4.80002C14 4.05329 14 3.67991 13.8547 3.3947C13.7269 3.14381 13.5229 2.93984 13.272 2.81201C12.9868 2.66669 12.6134 2.66669 11.8667 2.66669H4.13333C3.3866 2.66669 3.01323 2.66669 2.72801 2.81201C2.47713 2.93984 2.27315 3.14381 2.14533 3.3947C2 3.67991 2 4.05328 2 4.80002V11.2C2 11.9468 2 12.3202 2.14533 12.6054C2.27315 12.8562 2.47713 13.0602 2.72801 13.188C3.01323 13.3334 3.38659 13.3334 4.13333 13.3334Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
